import React, {Component} from "react";
import UserHeader from "./UserHeader";
import {connect} from "react-redux";
import {cancelPayment, getPayments} from "../../redux/actions/payments";
import Loading from "../../components/Loading";
import MomentDate from "../../components/MomentDate";
import PAYMENTS from "../../constants/payments";
import Check from "./Payments/Check";
import ReactDOM from "react-dom";
import PROVIDERS from "../../constants/providers";
import {LOCAL} from "../../constants/local";

class UserPayments extends Component {
	types = {
		[PAYMENTS.T_IN]  : 'Пополнение',
		[PAYMENTS.T_OUT] : 'Выплата',
		[PAYMENTS.T_DEL] : ''
	};

	methods = {
		[PAYMENTS.M_CASH]        : 'Касса',
		[PAYMENTS.M_ERIP]        : 'ЕРИП',
		[PAYMENTS.M_EASYPAY]     : 'EasyPay',
		[PAYMENTS.M_BELARUSBANK] : 'Беларусбанк',
		[PAYMENTS.M_BELGAZBANK]  : 'Белгазпромбанк',
		[PAYMENTS.M_NEW_ERIP]    : 'Банк',
		[PAYMENTS.M_EASYPAY_NEW] : 'EasyPay',
		[PAYMENTS.M_QIWI]        : 'QIWI',
		[PAYMENTS.M_MOBILE]      : 'Моб. тел.',
	};

	statuses = {
		[PAYMENTS.S_ORDERED]  : 'Заказано',
		[PAYMENTS.S_RESOLVED] : 'Подтверждено',
		[PAYMENTS.S_REPAID]   : 'Выплачено',
		[PAYMENTS.S_RETURN]   : 'Отменено',
		[PAYMENTS.S_DURING]   : 'В процессе',
	};

	componentWillMount() {
		this.props.onGetPayments(4);
	}

	getInfo(payment) {
		const params = "menubar=no,location=yes,resizable=no,scrollbars=no,status=no,width=500,height=300";
		const myWindow = window.open("about:blank", "Документ, подтверждающий выплату", params);
		myWindow.onload = () => {
			const div = myWindow.document.createElement('div'),
				body = myWindow.document.body;

			ReactDOM.render(<Check payment={payment}/>, div);
			body.insertBefore(div, body.firstChild);
		};
	}

	cancelPayment(payment_id) {
		this.props.onPaymentCancel(payment_id);
	}

	render() {
		const paymentsStorage = this.props.payments;
		const {payments, cancel} = paymentsStorage;

		return (
			<div>
				<UserHeader text={'История операций'}/>

				<div className="table-div profile__payment-history">
					<div className="thead">
						<div className="tr">
							<div className="th">Время</div>
							<div className="th">Операции</div>
							<div className="th">Сумма</div>
							<div className="th">Метод</div>
						</div>
					</div>

					<div className="tbody">
						{paymentsStorage.fetching && <Loading/>}
						{payments.map((payment) => {
								const json = payment.json !== "" && payment.json !== undefined ? JSON.parse(payment.json) : {};

								return (<div key={payment.id} className="tr">
									<div className="td time cl-gray">
										<MomentDate date={payment.time} isFormatDate={true}/>
									</div>
									<div className="td operation">
										<div>{this.types[parseInt(payment.type)]}</div>
										<div className="cl-gray">
											{parseInt(payment.type) !== PAYMENTS.T_IN && this.statuses[parseInt(payment.status)]}
											{/*{parseInt(payment.type) !== PAYMENTS.T_IN && parseInt(payment.status) === PAYMENTS.S_REPAID &&*/}
											{/*<span className="info-link" onClick={this.getInfo.bind(this, payment)}>Информация</span>}*/}
											{parseInt(payment.status) === PAYMENTS.S_ORDERED &&
											<span className="info-link" onClick={this.cancelPayment.bind(this, payment.id)}>Отменить</span>}
											{/*показываем сообщения при отмене выплаты*/}
											{parseInt(payment.status) === PAYMENTS.S_ORDERED && cancel.hasOwnProperty('messages') &&
											<span className="error">{cancel.messages}</span>}
										</div>
									</div>
									<div className="td method">{payment.amount} {LOCAL.currency}</div>
									<div className="td method">
										{this.methods[parseInt(payment.method)]}
										{+payment.method === 13 && <span>&nbsp;{PROVIDERS[+json.provider]}</span>}
										{+payment.method === 13 && <div>{json.phone}</div>}
									</div>
								</div>);
							}
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default connect(
	state => ({
		payments : state.payments
	}),
	dispatch => ({
		onGetPayments   : (period) => {
			dispatch(getPayments(period));
		},
		onPaymentCancel : (payment_id) => {
			dispatch(cancelPayment(payment_id));
		}
	})
)(UserPayments);


// WEBPACK FOOTER //
// ./src/app/pages/User/UserPayments.js